import {Injectable} from '@angular/core';
import {Restangular} from 'ngx-restangular';

@Injectable()
export class IcamService {

  constructor(private restangular: Restangular) {
  }

  iCamInvestigationCRUD() {
    return this.restangular.all('iCamInvestigationCRUD');
  }

  getInvestigationIcam() {
    return this.restangular.one('getInvestigationIcam');
  }

  removeIncidentNotificationIcam() {
    return this.restangular.one('removeIncidentNotificationIcam');
  }


  storeCausationalFactors() {
    return this.restangular.all('storeCausationalFactors');
  }




  
  iCamInvestigationCRUDAI() {
    return this.restangular.all('iCamInvestigationCRUDAI');
  }

  removeIncidentNotificationIcamAI() {
    return this.restangular.one('removeIncidentNotificationIcamAI');
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/icam.service.ts